import React from 'react';

import { StepOne, StepTwo, StepThree } from "../";
import { useCalc } from "../../store/hooks/useCalc";

import './styles.scss';

export const App = () => {
  const { stepOneData, stepTwoData } = useCalc();

  return (
    <div className="app">
      <StepOne />
      { stepOneData && <StepTwo /> }
      { stepTwoData && <StepThree /> }
    </div>
  );
};
